export const CONFIG = {
  API_URL: process.env.REACT_APP_API_URL, 
  FILE_SERVICE_API_URL: process.env.REACT_APP_FILE_SERVICE_API_URL,
};
